import { debug } from '../utils.js';

export const DEFAULT_AD_CHOICES_PRODUCT_ID = 'NOCON';

export async function resolveMonetizationInstance(_window, config = {}, timeoutMs = 10_000) {
    return new Promise((resolve, reject) => {
        if (_window.schMonetization) {
            return resolve(_window.schMonetization);
        }

        const timeoutTimer = setTimeout(() => {
            reject(
                new Error(
                    `@schibsted/sourcepoint: Timeout of ${timeoutMs}ms exceeded while waiting for schMonetization instance`,
                ),
            );
        }, timeoutMs);

        _window.addEventListener(
            'schMonetization:ready',
            ({ detail }) => {
                debug(
                    'schMonetization instance resolved from schMonetization:ready event ',
                    !!detail.instance,
                );
                clearTimeout(timeoutTimer);
                resolve(detail.instance);
            },
            { once: true },
        );
    });
}
